const EMPTY_TAG_VALUES = new Set(["null", "undefined", "[]", "{}"]);

export function normalizeTagValue(value: unknown): string | null {
	if (typeof value !== "string") return null;

	const normalized = value.trim();
	if (!normalized || EMPTY_TAG_VALUES.has(normalized.toLowerCase()))
		return null;

	return normalized;
}
